import { useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import Slider from "@react-native-community/slider";
import { Colors, Typography } from "../../../styles";
import Divider from "../Divider";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useDispatch } from "react-redux";
import { setVisibilityTarget } from "../../../redux/mainSlice";

const WatchedCard = () => {
  const dispatch = useDispatch();
  const [target, setTarget] = useState(50);
  return (
    <>
      <Text style={Typography.paragraph}>Target visibility {target}%</Text>
      <Slider
        style={{ width: "100%", height: 40 }}
        minimumValue={0}
        maximumValue={100}
        minimumTrackTintColor="#FFF"
        maximumTrackTintColor="#777"
        step={25}
        thumbTintColor={Colors.white}
        value={target}
        onSlidingComplete={(val) => {
          // TODO: update watchlist card
          // dispatch(setVisibilityTarget({ id: "1", target: val }));

          setTarget(val);
        }}
        onValueChange={(val) => setTarget(val)}
      />
      <Divider style={{ marginTop: 5 }} />
      {/* TODO: stop tracking card button */}
      <View style={styles.row}>
        <MaterialCommunityIcons
          name="stop-circle-outline"
          size={25}
          color={Colors.plum400}
          style={styles.icon}
        />

        <Text style={[Typography.paragraph, { color: Colors.plum300 }]}>
          Stop tracking this card
        </Text>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 20,
  },
  icon: {
    marginRight: 6,
  },
});

export default WatchedCard;
